import { Card, CardContent, List } from "@mui/material";
import { forwardRef, useCallback, useEffect, useMemo, useRef, useState } from "react";
import UserItem from "./UserItem";
import { useDispatch, useSelector } from "react-redux";
import { resetUser, setSelectedUser } from "store/settings/user/userSlice";
import UserDetails from "./UserDetails";
import styles from './Users.module.css';
import { useAddUserMutation, useDeleteUserMutation, useGetGrantsQuery, useGetUsersQuery, useUpdateUserMutation } from "services/data/userApi";
import { HidingError } from "components/errors";

const DEFAULT_ERROR = "Ошибка соединения с сервером";

const Users = forwardRef((props, ref) => {

  const dispatch = useDispatch();
  const { selectedUser } = useSelector(state => state.user);

  const { data: usersData, isError: isGetUsersError, error: usersError, isFetching: isFetchingUsers } = useGetUsersQuery();
  const { data: grantsData, isError: isGetGrantsError, error: grantsError, isFetching: isFetchingGrants } = useGetGrantsQuery({type: 'manager'});
  const [updateUser, {error: updateUserError, reset: updateUserReset}] = useUpdateUserMutation();
  const [addUser, {error: addUserError, reset: addUserReset}] = useAddUserMutation();
  const [deleteUser, {error: deleteUserError, reset: deleteUserReset}] = useDeleteUserMutation();

  const itemsRef = useRef([]);

  useEffect(()=> {
    itemsRef.current = itemsRef.current.slice(0, usersData?.body?.items.length);
  }, [usersData?.body?.items]);

  

  const [showError, setShowError] = useState(false);

  const getErrorMessage = () => { 
    if(isGetUsersError) return usersError?.data?.message ?? DEFAULT_ERROR;
    if(updateUserError) return updateUserError?.data?.msg ?? DEFAULT_ERROR;
    if(addUserError) return addUserError?.data?.msg ?? DEFAULT_ERROR;
    if(deleteUserError) return deleteUserError?.data?.msg ?? DEFAULT_ERROR;
    else return 'Ошибка';
  };
  
  const hideError = () => {
    setShowError(false); 
    updateUserError && updateUserReset();
    addUserError && addUserReset();
    deleteUserError && deleteUserReset();
  }

  useEffect(() => {
      isGetUsersError && setShowError(true);
      updateUserError && setShowError(true);
      addUserError && setShowError(true);
      deleteUserError && setShowError(true);
  }, [isGetUsersError, updateUserError, addUserError, deleteUserError]);

  const isItemSelected = useCallback((item) => item?.id===selectedUser?.id, [selectedUser]);
  const onItemSelect = useCallback((item) => { 
    isItemSelected(item) ? dispatch(resetUser()) : dispatch(setSelectedUser(item));
  }, [isItemSelected]);


  const blockItem = useCallback((id, isBlock) => {
    updateUser( {body: {disabled: isBlock}, id} );
  }, []);

  const deleteItem = useCallback((id) => {
    deleteUser( {id} );
  }, []);

  const saveUser = useCallback((params) => {     
     updateUser({body:params, id: selectedUser.id}).unwrap()
           .then((payload) => { 
             dispatch(setSelectedUser(payload.body));
           })
           .catch((error) => console.log(error));
  }, [selectedUser]);

  const insertUser = useCallback((params) => { 
    addUser({body: params}).unwrap()
          .then((payload) => { 
            dispatch(setSelectedUser(payload.body));
          })
          .catch((error) => console.log(error));
  }, [selectedUser]);

  const renderItems = usersData?.body?.items.map((item, index) => {
    return  <UserItem
                key={item.id}
                ref={el => itemsRef.current[index] = {id: item.id, el: el}}
                selected={isItemSelected(item)}
                onSelect={onItemSelect}
                onBlock={blockItem}
                onDelete={deleteItem}
                { ...item} 
            />;             
  });

  return (     
    <div ref={ref} className={styles.usersPage}>
      {<HidingError 
        open={ showError }
        message={ getErrorMessage() }
        onClose={ hideError }
      />}
      <div className="page-content">
        <div className="left">
          <div className="pagelist">
            <div className="pagelist-body">
              { <List sx={{padding:0}}>{renderItems}</List> }  
            </div>
          </div>
        </div>
        <div className="right">
          <div className={styles.details}>  
            <div className={styles.content}>
              <UserDetails
                user={selectedUser}
                addUser={insertUser}
                saveUser={saveUser}
                grants={grantsData?.body?.items}
              />
            </div> 
          </div>   
        </div>
      </div>
    </div>
  );
});

export default Users;